import { atom, atomWithDefault } from '~shared/lib/atom-state';

import { ApiRequest, getOrgInfo, getPortfolio } from '../api';

import { IOrgInfo, IPortfolio } from './types';

export const orgInfoAtom = atomWithDefault<IOrgInfo | null>((_get) => null);
export const portfolioAtom = atomWithDefault<IPortfolio | null>((_get) => null);

export const setOrgInfoAtom = atom<IOrgInfo | null, ApiRequest, Promise<void>>(
  (get) => get(orgInfoAtom),
  async (_get, set, { idOrganization }) => {
    const response = await getOrgInfo({ idOrganization });
    const data = response.data;
    set(orgInfoAtom, data);
  }
);

export const setPortfolioAtom = atom<IPortfolio | null, ApiRequest, Promise<void>>(
  (get) => get(portfolioAtom),
  async (_get, set, { idOrganization }) => {
    const response = await getPortfolio({ idOrganization });
    const data = response.data;

    set(portfolioAtom, data);
  }
);
